export default __webpack_public_path__ + "static/media/perro.c65ad43b.png";